import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import EmptyState from 'components/Catalog/ProductGrid/CompareModal/EmptyState/EmptyState';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CompareModalEN from 'components/Catalog/ProductGrid/CompareModal/locales/CompareModal_en_US';
import CompareModalFR from 'components/Catalog/ProductGrid/CompareModal/locales/CompareModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CompareModalEN, CompareModalFR);

const localization = createStructuredSelector({
    noValues: getTextFromResource(getText, 'noValues')
});

const fields = createSelector(localization, locale => {
    return { localization: locale };
});

const withEmptyStateProps = wrapHOC(connect(fields, null));

export default withEmptyStateProps(EmptyState);
